"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _Loader = _interopRequireDefault(require("../Loader/Loader"));

var _excluded = ["classes", "className", "primary", "secondary", "disabled", "loading", "children", "onClick"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = function styles(theme) {
  return {
    root: {
      userSelect: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      alignContent: 'center',
      textAlign: 'center',
      transition: 'background-color 0.3s ease-out 0s, border-color 0.3s ease-out 0s',
      cursor: 'pointer',
      border: 'none'
    },
    primary: _objectSpread(_objectSpread({
      padding: "".concat(theme.spacing.md, "px ").concat(theme.spacing.md * 2, "px"),
      backgroundColor: theme.palette.primary.medium,
      color: 'white'
    }, theme.typography.button1), {}, {
      textTransform: 'uppercase',
      fontSize: '1.25rem',
      '&:hover': {
        backgroundColor: theme.palette.primary.dark
      }
    }),
    secondary: _objectSpread(_objectSpread({
      padding: "".concat(theme.spacing.md, "px ").concat(theme.spacing.lg, "px"),
      backgroundColor: theme.palette.white,
      color: theme.palette.black,
      border: "1px solid ".concat(theme.palette.black),
      borderRadius: '3px',
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.white,
        border: "1px solid ".concat(theme.palette.primary.dark)
      }
    }, theme.typography.button2), {}, {
      fontSize: '.9rem',
      fontWeight: 400,
      letterSpacing: '1.44px'
    }),
    primaryDisabled: {
      backgroundColor: theme.palette.grey.medium,
      color: theme.palette.white,
      '&:hover': {
        backgroundColor: theme.palette.grey.medium,
        color: theme.palette.white
      },
      cursor: 'inherit'
    },
    secondaryDisabled: {
      backgroundColor: theme.palette.white,
      color: theme.palette.grey.medium,
      border: "1px solid ".concat(theme.palette.grey.medium),
      '&:hover': {
        backgroundColor: theme.palette.white,
        color: theme.palette.grey.medium,
        border: "1px solid ".concat(theme.palette.grey.medium)
      },
      cursor: 'inherit'
    },
    loader: {
      position: 'absolute'
    }
  };
};

var Button = function Button(props) {
  var _clsx;

  var classes = props.classes,
      className = props.className,
      primary = props.primary,
      secondary = props.secondary,
      disabled = props.disabled,
      loading = props.loading,
      children = props.children,
      onClick = props.onClick,
      rest = _objectWithoutProperties(props, _excluded);

  if (disabled || loading) {
    rest.onClick = null;
  }

  var buttonRef = _react["default"].useRef();

  function handleMouseDown() {
    buttonRef.current.blur();
  }

  return /*#__PURE__*/_react["default"].createElement("button", _extends({
    ref: buttonRef,
    onClickCapture: handleMouseDown,
    className: (0, _clsx2["default"])(classes.root, (_clsx = {}, _defineProperty(_clsx, classes.primary, primary), _defineProperty(_clsx, classes.secondary, secondary), _defineProperty(_clsx, classes.primaryDisabled, primary && disabled), _defineProperty(_clsx, classes.secondaryDisabled, secondary && disabled), _clsx), className),
    onClick: onClick
  }, rest), loading && /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
    size: "sm",
    className: classes.loader
  }), children);
};

Button.defaultProps = {
  classes: {}
};
Button.propTypes = {
  classes: _propTypes["default"].any,
  children: _propTypes["default"].any,
  onClick: _propTypes["default"].func.isRequired,
  className: _propTypes["default"].string,
  primary: _propTypes["default"].bool,
  secondary: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  loading: _propTypes["default"].bool
};

var _default = (0, _reactJss["default"])(styles)(Button);

exports["default"] = _default;